module.exports = __webpack_public_path__ + "static/media/tutorial-book-round-1-1-1-1.a7f95bc3.png";